export * from "/home/ubuntu/projects/master.powerlead-marketing/node_modules/react-i18next/dist/es/index.js"